// App configuration - URI agnostic for multi-container deployment
const config = {
  // Use relative paths - the Express server handles routing regardless of base path
  basePath: '',
  apiBasePath: './api',
  
  // For debugging
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

console.log('App config loaded:', {
  basePath: config.basePath,
  apiBasePath: config.apiBasePath,
  environment: process.env.NODE_ENV
});

export default config;